<page-heading [title]="'dashboard.dashboard.pageTitle' | translate" />

<ul class="nav nav-tabs nav-bordered" role="tablist">
  <li class="nav-item" role="presentation">
    <a
      class="nav-link active"
      id="attendances-tab"
      data-bs-toggle="tab"
      data-bs-target="#attendances"
      type="button"
      role="tab"
      aria-controls="attendances"
      aria-selected="true"
      >
      <i
        class="mdi mdi-cloud-download-outline download-icon d-md-none d-block"
      ></i>
      <span class="d-none d-md-inline">{{ 'dashboard.dashboard.tabAttendances' | translate }}</span>
    </a>
  </li>
  @if (getModuleCRM()) {
    <li class="nav-item" role="presentation">
      <a
        class="nav-link"
        id="crm-trend-tab"
        data-bs-toggle="tab"
        data-bs-target="#crm-trend"
        type="button"
        role="tab"
        aria-controls="crm-trend"
        aria-selected="false"
        >
        <i class="mdi mdi-file-document-outline d-md-none d-block"></i>
        <span class="d-none d-md-inline">CRM</span>
      </a>
    </li>
  }
  <li class="nav-item" role="presentation">
    <a
      class="nav-link"
      id="tv-tab"
      data-bs-toggle="tab"
      data-bs-target="#tv"
      type="button"
      role="tab"
      aria-controls="tv"
      aria-selected="false"
      >
      <i class="mdi mdi-television d-md-none d-block"></i>
      <span class="d-none d-md-inline">{{ 'dashboard.tv.tab' | translate }}</span>
    </a>
  </li>
  @if (isAdmin()) {
    <li class="nav-item" role="presentation">
      <a
        class="nav-link"
        id="goals-tab"
        data-bs-toggle="tab"
        data-bs-target="#goals"
        type="button"
        role="tab"
        aria-controls="goals"
        aria-selected="false"
        >
        <i class="mdi mdi-target d-md-none d-block"></i>
        <span class="d-none d-md-inline">{{ 'dashboard.dashboard.tabGoals' | translate }}</span>
      </a>
    </li>
  }
  <!-- <li class="nav-item" role="presentation">
  <a
    class="nav-link"
    id="tasks-tab"
    data-bs-toggle="tab"
    data-bs-target="#tasks"
    type="button"
    role="tab"
    aria-controls="tasks"
    aria-selected="false"
    >
    <i class="mdi mdi-file-document-outline d-md-none d-block"></i>
    <span class="d-none d-md-inline">Tarefas</span>
  </a>
</li> -->
</ul>

<div class="tab-content" id="tabComponentsContent">
  <div
    class="tab-pane fade show active"
    id="attendances"
    role="tabpanel"
    aria-labelledby="attendances-tab"
    >
    <div class="mt-3">
      <div class="card">
        <div class="card-body">
          <form class="row" [formGroup]="dashForm">
            <div class="col-xs-12 col-xl-5 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
                >
                <input
                  matStartDate
                  [placeholder]="'dashboard.dashboard.startDate' | translate"
                  formControlName="dateStart"
                  />
                <input
                  matEndDate
                  [placeholder]="'dashboard.dashboard.endDate' | translate"
                  formControlName="dateEnd"
                  />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'dashboard.dashboard.select' | translate"
                    >
                    <mat-option value="1">{{ 'dashboard.dashboard.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'dashboard.dashboard.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'dashboard.dashboard.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'dashboard.dashboard.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'dashboard.dashboard.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>

            <!-- Filter channel -->
            <div class="col-sm col-md-4 col-xl-2 btn-group trend-button">
              <button
                type="submit"
                class="btn btn-primary dropdown-toggle"
                [matMenuTriggerFor]="menuChannel"
                >
                {{ labelChannel || ('dashboard.dashboard.channelsLabel' | translate) }} <span class="caret"></span>
              </button>
              <mat-menu #menuChannel="matMenu">
                <button
                  mat-menu-item
                  [value]="-1"
                  (click)="onChannelSelect(-1)"
                  >
                  {{ 'dashboard.dashboard.all' | translate }}
                </button>
                @for (item of channelAttendant; track item?._id) {
                  <button
                    mat-menu-item
                    [value]="$safeNavigationMigration(item?._id)"
                    (click)="onChannelSelect($safeNavigationMigration(item?._id), $safeNavigationMigration(item?.name))"
                    >
                    {{ item.name }}
                  </button>
                }
              </mat-menu>
            </div>

            <!-- Filter department - Attendant -->
            @if (isAttendant()) {
              <div class="col-sm col-md-4 col-xl-3 btn-group trend-button">
                <button
                  type="submit"
                  class="btn btn-primary dropdown-toggle"
                  [matMenuTriggerFor]="menuDepartment"
                  >
                  {{ labelDepartment || ('dashboard.dashboard.departmentsLabel' | translate) }} <span class="caret"></span>
                </button>
                <mat-menu #menuDepartment="matMenu">
                  <button
                    mat-menu-item
                    [value]="-1"
                    (click)="onDepartmentSelect(-1)"
                    >
                    {{ 'dashboard.dashboard.all' | translate }}
                  </button>
                  @for (item of department; track item?._id) {
                    <button
                      mat-menu-item
                      [value]="$safeNavigationMigration(item?._id)"
                      (click)="onDepartmentSelect($safeNavigationMigration(item?._id), $safeNavigationMigration(item?.name))"
                      >
                      {{ item.name }}
                    </button>
                  }
                </mat-menu>
              </div>
            }

            <!-- Filter department - Supervisor -->
            @if (isSupervisor()) {
              <div class="col-sm col-md-4 col-xl-3 btn-group trend-button">
                <button
                  type="submit"
                  class="btn btn-primary dropdown-toggle"
                  [matMenuTriggerFor]="menuDepartment"
                  >
                  {{ labelDepartment || ('dashboard.dashboard.departmentsLabel' | translate) }} <span class="caret"></span>
                </button>
                <mat-menu #menuDepartment="matMenu">
                  <button
                    mat-menu-item
                    [value]="-1"
                    (click)="onDepartmentSelect(-1)"
                    >
                    {{ 'dashboard.dashboard.all' | translate }}
                  </button>
                  @for (item of listTeamChannel; track item?._id) {
                    <button
                      mat-menu-item
                      [value]="$safeNavigationMigration(item?.department?._id)"
                      (click)="
                        onDepartmentSelect(
                          $safeNavigationMigration(item?.department?._id),
                          $safeNavigationMigration(item?.department?.name)
                        )
                      "
                      >
                      {{ item.department.name }}
                    </button>
                  }
                </mat-menu>
              </div>
            }

            <!-- Filter department - Admin -->
            @if (isAdmin()) {
              <div class="col-sm col-md-4 col-xl-3 btn-group trend-button">
                <button
                  type="submit"
                  class="btn btn-primary dropdown-toggle"
                  [matMenuTriggerFor]="menuDepartment"
                  >
                  {{ labelDepartment || ('dashboard.dashboard.departmentsLabel' | translate) }} <span class="caret"></span>
                </button>
                <mat-menu #menuDepartment="matMenu">
                  <button
                    mat-menu-item
                    [value]="-1"
                    (click)="onDepartmentSelect(-1)"
                    >
                    {{ 'dashboard.dashboard.all' | translate }}
                  </button>
                  @for (item of department; track item?._id) {
                    <button
                      mat-menu-item
                      [value]="$safeNavigationMigration(item?._id)"
                      (click)="onDepartmentSelect($safeNavigationMigration(item?._id), $safeNavigationMigration(item?.name))"
                      >
                      {{ item.name }}
                    </button>
                  }
                </mat-menu>
              </div>
            }

            <!-- Filter user - Admin -->
            @if (isAdmin()) {
              <div class="col-sm col-md-4 col-xl-2 btn-group trend-button">
                <button
                  type="submit"
                  class="btn btn-primary dropdown-toggle"
                  [matMenuTriggerFor]="menuAttendant"
                  >
                  {{ labelAttendant || ('dashboard.dashboard.attendantsLabel' | translate) }} <span class="caret"></span>
                </button>
                <mat-menu #menuAttendant="matMenu">
                  <button
                    mat-menu-item
                    [value]="-1"
                    (click)="onAttendantSelect(-1)"
                    >
                    {{ 'dashboard.dashboard.all' | translate }}
                  </button>
                  @for (item of attendantsByTeam; track item?._id) {
                    <button
                      mat-menu-item
                      [value]="$safeNavigationMigration(item?._id)"
                      (click)="onAttendantSelect($safeNavigationMigration(item?._id), $safeNavigationMigration(item?.name))"
                      >
                      {{ item.name }}
                    </button>
                  }
                </mat-menu>
              </div>
            }

            <!-- Filter user - Supervisor -->
            @if (isSupervisor()) {
              <div class="col-sm col-md-4 col-xl-2 btn-group trend-button">
                <button
                  type="submit"
                  class="btn btn-primary dropdown-toggle"
                  [matMenuTriggerFor]="menuAttendant"
                  >
                  {{ labelAttendant || ('dashboard.dashboard.attendantsLabel' | translate) }} <span class="caret"></span>
                </button>
                <mat-menu #menuAttendant="matMenu">
                  <button
                    mat-menu-item
                    [value]="-1"
                    (click)="onAttendantSelect(-1)"
                    >
                    {{ 'dashboard.dashboard.all' | translate }}
                  </button>
                  @for (item of attendantsByTeam; track item?._id) {
                    <button
                      mat-menu-item
                      [value]="$safeNavigationMigration(item?._id)"
                      (click)="onAttendantSelect($safeNavigationMigration(item?._id), $safeNavigationMigration(item?.name))"
                      >
                      {{ item.name }}
                    </button>
                  }
                </mat-menu>
              </div>
            }
          </form>
        </div>
      </div>

      <!-- Now: what needs action. Live, never period-scoped: a queue is a fact about this minute. -->
      @if (attendanceLive) {
        <h4 class="mt-3 mb-2">{{ 'dashboard.dashboard.nowSectionTitle' | translate }}</h4>
        <div class="row g-3">
          <div class="col-12 col-sm-6 col-xl">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.nowQueueTitle' | translate }}</h5>
                  <!-- Badge and help sit together in the corner: the title then wraps on its
                       own, instead of pushing the icon onto a line of its own. -->
                  <span class="d-flex align-items-center gap-1 flex-shrink-0">
                    <span class="badge campaign-badge" [ngClass]="statusBadgeClass(queueStatus())">{{ statusLabel(queueStatus()) }}</span>
                    <i class="mdi mdi-information-outline text-muted"
                      tabindex="0"
                      [matTooltip]="'dashboard.dashboard.nowQueueHint' | translate:{ limit: attendanceLive.queueAlertAt }"
                      matTooltipPosition="above"
                      [attr.aria-label]="'dashboard.dashboard.nowQueueHint' | translate:{ limit: attendanceLive.queueAlertAt }"></i>
                  </span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(queueStatus())">{{ formatNumber(attendanceLive.queueNow) }}</h2>
                <p class="text-muted mb-2">{{ 'dashboard.dashboard.nowQueueSubtitle' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.nowDelayedTitle' | translate }}</h5>
                  <!-- Badge and help sit together in the corner: the title then wraps on its
                       own, instead of pushing the icon onto a line of its own. -->
                  <span class="d-flex align-items-center gap-1 flex-shrink-0">
                    <span class="badge campaign-badge" [ngClass]="statusBadgeClass(countStatus(attendanceLive.delayed, 1, 20))">{{ statusLabel(countStatus(attendanceLive.delayed, 1, 20)) }}</span>
                    <i class="mdi mdi-information-outline text-muted"
                      tabindex="0"
                      [matTooltip]="'dashboard.dashboard.nowDelayedHint' | translate"
                      matTooltipPosition="above"
                      [attr.aria-label]="'dashboard.dashboard.nowDelayedHint' | translate"></i>
                  </span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(countStatus(attendanceLive.delayed, 1, 20))">{{ formatNumber(attendanceLive.delayed) }}</h2>
                <p class="text-muted mb-2">{{ 'dashboard.dashboard.nowDelayedSubtitle' | translate:{ minutes: attendanceLive.staleAfterMinutes } }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.nowOutOfHoursTitle' | translate }}</h5>
                  <!-- Badge and help sit together in the corner: the title then wraps on its
                       own, instead of pushing the icon onto a line of its own. -->
                  <span class="d-flex align-items-center gap-1 flex-shrink-0">
                    <span class="badge campaign-badge" [ngClass]="statusBadgeClass(countStatus(attendanceLive.outOfHoursPendingCount, 1, 5))">{{ statusLabel(countStatus(attendanceLive.outOfHoursPendingCount, 1, 5)) }}</span>
                    <i class="mdi mdi-information-outline text-muted"
                      tabindex="0"
                      [matTooltip]="'dashboard.dashboard.nowOutOfHoursHint' | translate"
                      matTooltipPosition="above"
                      [attr.aria-label]="'dashboard.dashboard.nowOutOfHoursHint' | translate"></i>
                  </span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(countStatus(attendanceLive.outOfHoursPendingCount, 1, 5))">{{ formatMinutes(attendanceLive.outOfHoursPendingMaxMinutes) }}</h2>
                <p class="text-muted mb-2">{{ 'dashboard.dashboard.nowOutOfHoursSubtitle' | translate:{ count: attendanceLive.outOfHoursPendingCount } }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.nowCapacityTitle' | translate }}</h5>
                  <!-- Badge and help sit together in the corner: the title then wraps on its
                       own, instead of pushing the icon onto a line of its own. -->
                  <span class="d-flex align-items-center gap-1 flex-shrink-0">
                    <span class="badge campaign-badge" [ngClass]="statusBadgeClass(getNumberOnline() > 0 ? 'OK' : 'ATTENTION')">{{ statusLabel(getNumberOnline() > 0 ? 'OK' : 'ATTENTION') }}</span>
                    <i class="mdi mdi-information-outline text-muted"
                      tabindex="0"
                      [matTooltip]="'dashboard.dashboard.nowCapacityHint' | translate"
                      matTooltipPosition="above"
                      [attr.aria-label]="'dashboard.dashboard.nowCapacityHint' | translate"></i>
                  </span>
                </div>
                <h2 class="mb-1 text-nowrap">{{ getNumberOnline() }} / {{ attendantsInScope.length }}</h2>
                <p class="text-muted mb-2">{{ 'dashboard.dashboard.nowCapacitySubtitle' | translate }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.nowStaleTitle' | translate }}</h5>
                  <!-- Badge and help sit together in the corner: the title then wraps on its
                       own, instead of pushing the icon onto a line of its own. -->
                  <span class="d-flex align-items-center gap-1 flex-shrink-0">
                    <span class="badge campaign-badge" [ngClass]="statusBadgeClass(countStatus(attendanceLive.staleChats, 1, 10))">{{ statusLabel(countStatus(attendanceLive.staleChats, 1, 10)) }}</span>
                    <i class="mdi mdi-information-outline text-muted"
                      tabindex="0"
                      [matTooltip]="'dashboard.dashboard.nowStaleHint' | translate"
                      matTooltipPosition="above"
                      [attr.aria-label]="'dashboard.dashboard.nowStaleHint' | translate"></i>
                  </span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(countStatus(attendanceLive.staleChats, 1, 10))">{{ formatNumber(attendanceLive.staleChats) }}</h2>
                <p class="text-muted mb-2">{{ 'dashboard.dashboard.nowStaleSubtitle' | translate:{ minutes: attendanceLive.staleAfterMinutes } }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- The out-of-hours conversations nobody has answered yet, so the card can be acted on. -->
        @if (attendanceLive.outOfHoursPending.length > 0) {
          <div class="card mt-3">
            <div class="card-body">
              <h4 class="header-title mb-1">{{ 'dashboard.dashboard.outOfHoursPendingTitle' | translate }}</h4>
              <p class="text-muted mb-3">{{ 'dashboard.dashboard.outOfHoursPendingSubtitle' | translate }}</p>
              <div class="table-responsive">
                <table class="table table-hover table-centered mb-0">
                  <thead>
                    <tr>
                      <th class="text-primary-emphasis">{{ 'dashboard.dashboard.outOfHoursColumnContact' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'dashboard.dashboard.outOfHoursColumnDepartment' | translate }}</th>
                      <th class="text-primary-emphasis">{{ 'dashboard.dashboard.outOfHoursColumnArrived' | translate }}</th>
                      <th class="text-primary-emphasis text-end">{{ 'dashboard.dashboard.outOfHoursColumnWaiting' | translate }}</th>
                      <th class="text-primary-emphasis text-end">{{ 'dashboard.dashboard.outOfHoursColumnSinceOpening' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (item of attendanceLive.outOfHoursPending; track item.idAttendance) {
                      <tr>
                        <td>
                          <div class="d-flex flex-column">
                            <span class="fw-bold">{{ item.contactName }}</span>
                            <small class="text-muted">{{ item.protocol }}</small>
                          </div>
                        </td>
                        <td>{{ item.departmentName }}</td>
                        <td>{{ item.arrivedAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                        <td class="text-end fw-bold text-danger">{{ formatMinutes(item.waitingMinutes) }}</td>
                        <td class="text-end">{{ formatMinutes(item.waitingSinceOpeningMinutes) }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        }
      }

      <!-- Today against the goal -->
      @if (overview) {
        <h4 class="mt-4 mb-2">{{ 'dashboard.dashboard.goalSectionTitle' | translate }}</h4>
        <div class="row g-3">
          <div class="col-12 col-sm-6 col-xl-4">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.goalSlaTitle' | translate }}</h5>
                  <span class="badge campaign-badge" [ngClass]="statusBadgeClass(overview.sla.status)">{{ statusLabel(overview.sla.status) }}</span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(overview.sla.status)">{{ formatPercent(overview.sla.value) }}</h2>
                <p class="text-muted mb-1">{{ 'dashboard.dashboard.goalSlaSubtitle' | translate:{ minutes: overview.goals.firstResponseMinutes } }}</p>
                <p class="small text-muted mb-0">{{ 'dashboard.dashboard.goalSlaTarget' | translate:{ target: overview.sla.target, minutes: overview.goals.firstResponseMinutes } }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl-4">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.goalTmeTitle' | translate }}</h5>
                  <span class="badge campaign-badge" [ngClass]="statusBadgeClass(overview.tme.status)">{{ statusLabel(overview.tme.status) }}</span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(overview.tme.status)">{{ formatMinutes(overview.tme.p90) }}</h2>
                <p class="text-muted mb-1">{{ 'dashboard.dashboard.goalTmeSubtitle' | translate }}</p>
                <p class="small text-muted mb-1">{{ 'dashboard.dashboard.goalTmeDetail' | translate:{ median: formatMinutes(overview.tme.median), average: formatMinutes(overview.tme.average) } }}</p>
                @if (overview.tme.openCount > 0) {
                  <p class="small text-danger mb-0">{{ 'dashboard.dashboard.goalStillWaiting' | translate:{ count: overview.tme.openCount, longest: formatMinutes(overview.tme.openMaxMinutes) } }}</p>
                }
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl-4">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.goalTmaTitle' | translate }}</h5>
                  <span class="badge campaign-badge" [ngClass]="statusBadgeClass(overview.tma.status)">{{ statusLabel(overview.tma.status) }}</span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(overview.tma.status)">{{ formatMinutes(overview.tma.p90) }}</h2>
                <p class="text-muted mb-1">{{ 'dashboard.dashboard.goalTmaSubtitle' | translate }}</p>
                <p class="small text-muted mb-0">{{ 'dashboard.dashboard.goalTmaDetail' | translate:{ median: formatMinutes(overview.tma.median), average: formatMinutes(overview.tma.average) } }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl-4">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.goalTmfTitle' | translate }}</h5>
                  <span class="badge campaign-badge" [ngClass]="statusBadgeClass(overview.tmf.status)">{{ statusLabel(overview.tmf.status) }}</span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(overview.tmf.status)">{{ formatMinutes(overview.tmf.p90) }}</h2>
                <p class="text-muted mb-1">{{ 'dashboard.dashboard.goalTmfSubtitle' | translate }}</p>
                <p class="small text-muted mb-1">{{ 'dashboard.dashboard.goalTmfFromOpening' | translate:{ value: formatMinutes(overview.tmfFromOpening.p90) } }}</p>
                @if (overview.tmf.openCount > 0) {
                  <p class="small text-danger mb-0">{{ 'dashboard.dashboard.goalStillWaiting' | translate:{ count: overview.tmf.openCount, longest: formatMinutes(overview.tmf.openMaxMinutes) } }}</p>
                }
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl-4">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.goalAbandonmentTitle' | translate }}</h5>
                  <span class="badge campaign-badge" [ngClass]="statusBadgeClass(overview.abandonment.status)">{{ statusLabel(overview.abandonment.status) }}</span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(overview.abandonment.status)">{{ formatPercent(overview.abandonment.value) }}</h2>
                <p class="text-muted mb-1">{{ 'dashboard.dashboard.goalAbandonmentSubtitle' | translate }}</p>
                <p class="small text-muted mb-0">{{ 'dashboard.dashboard.goalAbandonmentTarget' | translate:{ target: overview.abandonment.target } }}</p>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-xl-4">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-start mb-1 gap-2">
                  <h5 class="header-title mb-0">{{ 'dashboard.dashboard.goalVolumeTitle' | translate }}</h5>
                  <span class="badge campaign-badge" [ngClass]="statusBadgeClass(overview.volume.status)">{{ statusLabel(overview.volume.status) }}</span>
                </div>
                <h2 class="mb-1 text-nowrap" [ngClass]="statusTextClass(overview.volume.status)">{{ formatSigned(overview.volume.variation) }}</h2>
                <p class="text-muted mb-1">{{ 'dashboard.dashboard.goalVolumeSubtitle' | translate }}</p>
                <p class="small text-muted mb-0">{{ 'dashboard.dashboard.goalVolumeDetail' | translate:{ current: overview.volume.current, previous: overview.volume.previous, tolerance: overview.volume.tolerance } }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Where the customer's time goes, what the waiting costs, and the money already on the board.
             These three read as lists, not as plotted charts: at a third of the row's width an
             ngx-charts axis shrank thirteen departments to slivers and printed two empty bands,
             while the number that matters — the time, the share — had to be guessed off an axis.
             A themed progress bar carries the proportion and the exact figure sits next to it. -->
        <div class="row g-3 mt-1">
          <div class="col-12 col-xl-4">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <h4 class="header-title mb-1">{{ 'dashboard.dashboard.journeyTitle' | translate }}</h4>
                <p class="text-muted mb-2">{{ 'dashboard.dashboard.journeySubtitle' | translate }}</p>

                @if (journeyRows.length > 0) {
                  <p class="small text-muted mb-3">
                    <i class="mdi mdi-circle text-primary me-1"></i>{{ 'dashboard.dashboard.journeyWait' | translate }}
                    <i class="mdi mdi-circle text-info ms-3 me-1"></i>{{ 'dashboard.dashboard.journeyHandling' | translate }}
                  </p>

                  @for (row of journeyRows; track row.idDepartment) {
                    <div class="mb-3">
                      <div class="d-flex justify-content-between align-items-baseline gap-2 mb-1">
                        <span class="text-truncate">
                          <span class="fw-bold">{{ row.departmentName || ('dashboard.dashboard.withoutDepartment' | translate) }}</span>
                          <!-- The department or its channel was deleted. It still counts: during this
                               period it existed and carried these conversations. -->
                          @if (row.removed) {
                            <span class="badge campaign-badge is-err ms-1">{{ 'dashboard.dashboard.removedBadge' | translate }}</span>
                          }
                        </span>
                        <small class="text-muted text-nowrap">{{ formatMinutes(row.totalMinutes) }}</small>
                      </div>
                      <div class="progress" role="progressbar" [attr.aria-label]="row.departmentName">
                        <div class="progress-bar bg-primary" [style.width.%]="journeyShare(row.waitMinutes)"></div>
                        <div class="progress-bar bg-info" [style.width.%]="journeyShare(row.handlingMinutes)"></div>
                      </div>
                      <small class="text-muted">
                        {{ 'dashboard.dashboard.journeyDetail' | translate:{ wait: formatMinutes(row.waitMinutes), handling: formatMinutes(row.handlingMinutes) } }}
                        @if (journeyCaption(row.bottleneck)) {
                          · {{ journeyCaption(row.bottleneck) }}
                        }
                      </small>
                    </div>
                  }

                  @if (hiddenJourneyCount > 0 || showAllJourney) {
                    <button type="button" class="btn btn-sm btn-soft-primary w-auto" (click)="toggleJourney()">
                      {{ showAllJourney
                        ? ('dashboard.dashboard.journeyShowLess' | translate)
                        : ('dashboard.dashboard.journeyShowAll' | translate:{ count: hiddenJourneyCount }) }}
                    </button>
                  }
                } @else {
                  <p class="text-muted mb-0">{{ 'dashboard.dashboard.noDataForPeriod' | translate }}</p>
                }
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <h4 class="header-title mb-1">{{ 'dashboard.dashboard.waitingAnswersTitle' | translate }}</h4>
                <p class="text-muted mb-3">{{ 'dashboard.dashboard.waitingAnswersSubtitle' | translate }}</p>

                @for (band of overview.waitingAnswers; track band.key) {
                  <div class="mb-3">
                    <div class="d-flex justify-content-between align-items-baseline gap-2 mb-1">
                      <span class="fw-bold">{{ waitingBandLabel(band.key) }}</span>
                      <small class="text-muted text-nowrap">{{ band.answered }}</small>
                    </div>
                    <div class="progress" role="progressbar" [attr.aria-label]="waitingBandLabel(band.key)">
                      <div class="progress-bar bg-info" [style.width.%]="band.share ?? 0"></div>
                    </div>
                    <small class="text-muted">
                      {{ 'dashboard.dashboard.waitingAnswersDetail' | translate:{ share: formatPercent(band.share) } }}
                    </small>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-4">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <h4 class="header-title mb-1">{{ 'dashboard.dashboard.moneyTitle' | translate }}</h4>
                <p class="text-muted mb-3">{{ 'dashboard.dashboard.moneySubtitle' | translate }}</p>

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                  <div>
                    <span class="fw-bold d-block">{{ 'dashboard.dashboard.moneyAtRisk' | translate }}</span>
                    <small class="text-muted">{{ 'dashboard.dashboard.moneyAtRiskDetail' | translate:{ queue: overview.money.revenueAtRiskQueue, ticket: (overview.goals.averageTicket | currency:'BRL':'symbol':'1.0-0') } }}</small>
                  </div>
                  <h4 class="mb-0 text-primary">{{ overview.money.revenueAtRisk | currency:'BRL':'symbol':'1.0-0' }}</h4>
                </div>

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                  <div>
                    <span class="fw-bold d-block">{{ 'dashboard.dashboard.moneyLost' | translate }}</span>
                    <small class="text-muted">{{ 'dashboard.dashboard.moneyLostDetail' | translate:{ leads: overview.money.lostToDelayLeads, minutes: overview.goals.firstResponseMinutes } }}</small>
                  </div>
                  <h4 class="mb-0 text-primary">{{ overview.money.lostToDelay | currency:'BRL':'symbol':'1.0-0' }}</h4>
                </div>

                <p class="text-uppercase text-muted small mb-2 mt-3">{{ 'dashboard.dashboard.moneyCrmTitle' | translate }}</p>

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                  <div>
                    <span class="fw-bold d-block">{{ 'dashboard.dashboard.moneyCrmOpen' | translate }}</span>
                    <small class="text-muted">{{ 'dashboard.dashboard.moneyCrmOpenDetail' | translate:{ count: overview.money.crm.openCount } }}</small>
                  </div>
                  <h4 class="mb-0 text-primary">{{ overview.money.crm.openValue | currency:'BRL':'symbol':'1.0-0' }}</h4>
                </div>

                <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                  <div>
                    <span class="fw-bold d-block">{{ 'dashboard.dashboard.moneyCrmWon' | translate }}</span>
                    <small class="text-muted">{{ 'dashboard.dashboard.moneyCrmWonDetail' | translate:{ count: overview.money.crm.wonCount } }}</small>
                  </div>
                  <h4 class="mb-0 text-success">{{ overview.money.crm.wonValue | currency:'BRL':'symbol':'1.0-0' }}</h4>
                </div>

                <div class="d-flex justify-content-between align-items-center">
                  <div>
                    <span class="fw-bold d-block">{{ 'dashboard.dashboard.moneyCrmLost' | translate }}</span>
                    <small class="text-muted">{{ 'dashboard.dashboard.moneyCrmLostDetail' | translate:{ count: overview.money.crm.lostCount } }}</small>
                  </div>
                  <h4 class="mb-0 text-danger">{{ overview.money.crm.lostValue | currency:'BRL':'symbol':'1.0-0' }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- The P90 note closes the block that uses it — the goal cards and the three panels —
             instead of interrupting it right after the cards. -->
        <div class="alert alert-info mt-3 mb-0 py-2" role="alert">
          <h5 class="alert-heading mt-0 mb-1"><i class="mdi mdi-information-outline me-1"></i>{{ 'dashboard.dashboard.p90Title' | translate }}</h5>
          <p class="mb-0">{{ 'dashboard.dashboard.p90Explanation' | translate }}</p>
        </div>

        <h4 class="mt-4 mb-2">{{ 'dashboard.dashboard.periodSummaryTitle' | translate }}</h4>
      }

      <!-- Resumo do período: eight counters on ONE grid.
           They used to mix `col-xl-3` and `col-md-4` in the same row, which laid out as four,
           then three of two different widths, then one orphan on a line of its own. Eight
           equal quarters give two full rows at every breakpoint: 4 + 4 on a desktop, 2 + 2 +
           2 + 2 on a tablet, stacked on a phone.
           The four status counters come first — they are what the operation is doing right
           now — and the totals follow. TMF, TME and TMA moved to "Hoje contra a meta" above,
           with their median, their P90 and whoever is still waiting; TMTA was a sum of
           averages and is replaced by the time to resolve, measured attendance by attendance. -->
      @if (!loadingContent) {
        <div class="row g-3">
          <div class="col-12 col-sm-6 col-xl-3">
            <card-graphic-small-component
              [label]="'dashboard.dashboard.attendancesInProgress' | translate"
              class="card-button-hover"
              [total]="dashboardAttendancesKPIs?.countInProgress.toString()"
              (click)="openModalAttendance('IN_PROGRESS')"
              />
          </div>
          <div class="col-12 col-sm-6 col-xl-3">
            <card-graphic-small-component
              [label]="'dashboard.dashboard.attendancesPaused' | translate"
              class="card-button-hover"
              [total]="dashboardAttendancesKPIs?.countPaused.toString()"
              (click)="openModalAttendance('PAUSED')"
              />
          </div>
          <div class="col-12 col-sm-6 col-xl-3">
            <card-graphic-small-component
              [label]="'dashboard.dashboard.attendancesPending' | translate"
              class="card-button-hover"
              [total]="dashboardAttendancesKPIs?.countPending.toString()"
              (click)="openModalAttendance('PENDING')"
              />
          </div>
          <div class="col-12 col-sm-6 col-xl-3">
            <card-graphic-small-component
              [label]="'dashboard.dashboard.attendancesClosed' | translate"
              class="card-button-hover"
              [total]="dashboardAttendancesKPIs?.countClosed.toString()"
              (click)="openModalAttendance('CLOSED')"
              />
          </div>

          <div class="col-12 col-sm-6 col-xl-3">
            <card-graphic-small-component
              [label]="'dashboard.dashboard.totalContacts' | translate"
              [total]="totalContacts"
              />
          </div>
          <div class="col-12 col-sm-6 col-xl-3">
            <card-graphic-small-component
              [label]="'dashboard.dashboard.onlineTotalAttendants' | translate"
              [total]="getNumberOnline() + ' / ' + attendantsInScope.length.toString()"
              />
          </div>
          <div class="col-12 col-sm-6 col-xl-3">
            <!-- The note and how many answers it rests on come from the SAME reading, so the card
                 cannot show an average from one set and a count from another. A dash here means
                 nobody rated in the period, never "everybody rated it zero". -->
            <card-graphic-small-component
              [label]="'dashboard.dashboard.attendancesRatingOverall' | translate"
              [total]="formatCsat(overview?.summary?.averageCsat)"
              [description]="'dashboard.dashboard.ratedAttendances' | translate:{ count: overview?.summary?.ratedAttendances ?? 0 }"
              />
          </div>
          <div class="col-12 col-sm-6 col-xl-3">
            <card-graphic-small-component
              [label]="'dashboard.dashboard.timeToResolve' | translate"
              [total]="formatMinutes(overview?.summary?.timeToResolve?.median)"
              />
          </div>
        </div>
      }

      <!-- What the numbers say: readings computed by the API, translated here. -->
      @if (overview && visibleInsights.length > 0) {
        <h4 class="mt-4 mb-2">{{ 'dashboard.dashboard.insightsTitle' | translate }}</h4>
        <div class="row g-3">
          @for (insight of visibleInsights; track insight.key) {
            <div class="col-12 col-sm-6 col-xl-3">
              <div class="card h-100 mb-0">
                <div class="card-body">
                  <h5 class="header-title mb-1">{{ insightTitle(insight) }}</h5>
                  <h3 class="text-primary mb-1">{{ insightValue(insight) }}</h3>
                  <p class="text-muted mb-0">{{ insightText(insight) }}</p>
                </div>
              </div>
            </div>
          }
        </div>
        @if (allInsights.length > visibleInsights.length || showAllInsights) {
          <div class="text-center mt-3">
            <button type="button" class="btn btn-primary" (click)="toggleInsights()">
              {{ (showAllInsights ? 'dashboard.dashboard.insightsShowLess' : 'dashboard.dashboard.insightsShowAll') | translate }}
            </button>
          </div>
        }
      }

      <!-- Rhythm of the operation: the four readings of when the conversations arrive.
           The charts defer on a timer as a fallback for `on idle`: in Angular 22 an error thrown by
           any template during the change detection that follows an idle trigger leaves the remaining
           `on idle` blocks unrendered. -->
      @defer (on idle; on timer(1s)) {
        <h4 class="mt-4 mb-2">{{ 'dashboard.dashboard.rhythmTitle' | translate }}</h4>
        <div class="card rhythm-charts">
          <div class="card-body">
            <!-- `w-auto` + `text-nowrap`: `.trend-button button` is `width: 100%`, written for
                 the icon-only toggles, and it made the four options share the width equally
                 and break their labels over two lines. Here each option is as wide as its own
                 label. `flex-wrap` then wraps the BUTTONS, never their text, on a narrow screen. -->
            <!-- Every chart in this card is square-cornered. ngx-charts 25 cannot round a stacked
                 chart — `BarVerticalStackedComponent` never forwards `roundEdges` to its series —
                 so square is the only shape the four views can share. -->
            <div class="btn-group trend-button gap-1 mb-3 flex-wrap" role="group" [attr.aria-label]="'dashboard.dashboard.rhythmTitle' | translate">
              <button type="button" class="btn w-auto text-nowrap"
                [class.btn-primary]="rhythmView === 'HOUR'"
                [class.btn-outline-secondary]="rhythmView !== 'HOUR'"
                (click)="setRhythmView('HOUR')">
                {{ 'dashboard.dashboard.rhythmByHour' | translate }}
              </button>
              <button type="button" class="btn w-auto text-nowrap"
                [class.btn-primary]="rhythmView === 'SHIFT'"
                [class.btn-outline-secondary]="rhythmView !== 'SHIFT'"
                (click)="setRhythmView('SHIFT')">
                {{ 'dashboard.dashboard.rhythmByShift' | translate }}
              </button>
              <button type="button" class="btn w-auto text-nowrap"
                [class.btn-primary]="rhythmView === 'WEEKDAY'"
                [class.btn-outline-secondary]="rhythmView !== 'WEEKDAY'"
                (click)="setRhythmView('WEEKDAY')">
                {{ 'dashboard.dashboard.rhythmByWeekday' | translate }}
              </button>
              <button type="button" class="btn w-auto text-nowrap"
                [class.btn-primary]="rhythmView === 'CHANNEL'"
                [class.btn-outline-secondary]="rhythmView !== 'CHANNEL'"
                (click)="setRhythmView('CHANNEL')">
                {{ 'dashboard.dashboard.rhythmByChannel' | translate }}
              </button>
            </div>

            @switch (rhythmView) {
              @case ('HOUR') {
                <h4 class="header-title mb-1">{{ 'dashboard.dashboard.peakAttendanceByHourTitle' | translate }}</h4>
                <p class="text-muted mb-2">{{ 'dashboard.dashboard.peakAttendanceByHourSubtitle' | translate }}</p>
                <div class="overflow-hidden" #ContainerLineRef>
                  <ngx-charts-bar-vertical
                    [view]="viewLine"
                    [results]="dataByHours"
                    [scheme]="colorScheme"
                    [roundEdges]="false"
                    [gradient]="false"
                    [xAxis]="true"
                    [yAxis]="true"
                    [xAxisLabel]="'dashboard.dashboard.chartAxisHour' | translate"
                    [yAxisLabel]="'dashboard.dashboard.chartAxisValue' | translate">
                  </ngx-charts-bar-vertical>
                </div>
              }
              @case ('SHIFT') {
                <h4 class="header-title mb-1">{{ 'dashboard.dashboard.arrivalsByShiftTitle' | translate }}</h4>
                <p class="text-muted mb-2">{{ 'dashboard.dashboard.arrivalsByShiftSubtitle' | translate:{ share: formatPercent(overview?.outOfHoursShare) } }}</p>
                <div class="overflow-hidden" #ContainerLineRef>
                  <ngx-charts-bar-vertical-stacked
                    [view]="viewLine"
                    [results]="arrivalsByHourSeries"
                    [scheme]="colorScheme"
                    [roundEdges]="false"
                    [gradient]="false"
                    [xAxis]="true"
                    [yAxis]="true"
                    [legend]="true"
                    legendTitle=""
                    [xAxisLabel]="'dashboard.dashboard.chartAxisHour' | translate"
                    [yAxisLabel]="'dashboard.dashboard.chartAxisValue' | translate">
                  </ngx-charts-bar-vertical-stacked>
                </div>
              }
              @case ('WEEKDAY') {
                <div class="row">
                  <div class="col-12 col-xl-6 overflow-hidden">
                    <h4 class="header-title mb-1">{{ 'dashboard.dashboard.peakDailyAttendancesTitle' | translate }}</h4>
                    <p class="text-muted mb-2">{{ 'dashboard.dashboard.peakDailyAttendancesSubtitle' | translate }}</p>
                    <div class="overflow-hidden" #ContainerLineRef>
                      <ngx-charts-bar-vertical
                        [view]="viewLine"
                        [results]="peakAttendance"
                        [scheme]="colorScheme"
                        [roundEdges]="false"
                        [gradient]="false"
                        [xAxis]="true"
                        [yAxis]="true"
                        [legend]="legendLC"
                        [xAxisLabel]="'dashboard.dashboard.chartAxisWeekday' | translate"
                        [yAxisLabel]="'dashboard.dashboard.chartAxisValue' | translate">
                      </ngx-charts-bar-vertical>
                    </div>
                  </div>
                  <div class="col-12 col-xl-6 overflow-hidden">
                    <h4 class="header-title mb-1">{{ 'dashboard.dashboard.newContactsByDayTitle' | translate }}</h4>
                    <p class="text-muted mb-2">{{ 'dashboard.dashboard.newContactsByDaySubtitle' | translate }}</p>
                    <div class="overflow-hidden" #ContainerLineRef>
                      <ngx-charts-bar-vertical
                        [view]="viewLine"
                        [results]="newContactWeekend"
                        [scheme]="colorScheme"
                        [roundEdges]="false"
                        [gradient]="false"
                        [xAxis]="true"
                        [yAxis]="true"
                        [legend]="legendLC"
                        [xAxisLabel]="'dashboard.dashboard.chartAxisWeekday' | translate"
                        [yAxisLabel]="'dashboard.dashboard.chartAxisValue' | translate">
                      </ngx-charts-bar-vertical>
                    </div>
                  </div>
                </div>
              }
              @case ('CHANNEL') {
                <!-- A list, not a donut: the donut truncated every channel name to "Trend Soluçõe…",
                     gave slices colours that mean nothing, and left the reader counting rings to
                     compare two channels. The same shape the other two panels use. -->
                <h4 class="header-title mb-1">{{ 'dashboard.dashboard.newContactsByChannelTitle' | translate }}</h4>
                <p class="text-muted mb-3">{{ 'dashboard.dashboard.newContactsByChannelSubtitle' | translate }}</p>
                @if (newContactRows.length > 0) {
                  @for (row of newContactRows; track row.name) {
                    <div class="mb-3">
                      <div class="d-flex justify-content-between align-items-baseline gap-2 mb-1">
                        <span class="fw-bold text-truncate">{{ row.name }}</span>
                        <small class="text-muted text-nowrap">{{ formatNumber(row.value) }} ({{ formatPercent(row.percent) }})</small>
                      </div>
                      <div class="progress" role="progressbar" [attr.aria-label]="row.name">
                        <div class="progress-bar bg-info" [style.width.%]="row.share"></div>
                      </div>
                    </div>
                  }
                } @else {
                  <p class="text-muted mb-0">{{ 'dashboard.dashboard.noDataForPeriod' | translate }}</p>
                }
              }
            }
          </div>
        </div>
      } @placeholder {
        <div>{{ 'dashboard.dashboard.loading' | translate }}</div>
      }

<!-- Metrics of campaign -->
@defer (on viewport) {
@if (campaign.length > 0) {
  <div class="row">
    @for (item of campaign; track $index) {
      <div class="col-xs-12 col-xl">
        <div class="card">
          <div class="card-body">
            <div class="row align-items-center">
              <div class="col-8">
                <h5
                  class="text-muted fw-normal mt-0 text-truncate"
                  title="{{ item.channelName }}"
                  >
                  {{ item.channelName }}
                </h5>
                <p class="text-muted">
                  <span class="me-2" [title]="'dashboard.dashboard.totalMessages' | translate"
                    ><i class="ri-message-2-line"></i>
                    {{ item?.totalMessages }}</span
                    >
                    <span class="me-2" [title]="'dashboard.dashboard.totalCampaigns' | translate"
                      ><i class="ri-volume-up-line"></i>
                      {{ item?.totalRecord }}</span
                      >
                    </p>
                    <p class="featured-info__text mb-0 py-0">
                      <em>{{ 'dashboard.dashboard.cost' | translate }}</em>
                    </p>
                    <h3 class="featured-info__text my-0">
                      {{ (item?.coust ?? 0) | currency: "BRL" : "symbol" : "1.2-2" }}
                    </h3>
                  </div>
                  <div class="col-4 text-end">
                    <img
                      class="rounded-circle featured-channel"
                          [src]="campaignChannelIcon(item)"
                      (error)="onImageError($event)"
                      alt="{{ item.channelName }}"
                      />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="card">
        <div class="card-body card-body--campaing">
          <i class="mdi mdi-volume-source"></i>
          <div>
            <h3>{{ 'dashboard.dashboard.noCampaignFoundTitle' | translate }}</h3>
            <p>{{ 'dashboard.dashboard.noCampaignFoundSubtitle' | translate }}</p>
          </div>
        </div>
      </div>
    }
    } @placeholder {
    <div>{{ 'dashboard.dashboard.loading' | translate }}</div>
  }

  <!-- Performance attendant table -->
  @defer (on viewport) {
  <div class="card">
    @if (
      (attendanceOn.total > 0 || attendanceOn.list.length > 0) &&
      !(loadingSpinner$ | async)
      ) {
      <div class="d-flex card-header card-header--icon">
        <i class="mdi mdi-account"></i>
        <div>
          <h3>{{ 'dashboard.dashboard.attendantsPerformanceTitle' | translate }}</h3>
          <h5 class="text-muted fw-normal">
            {{ 'dashboard.dashboard.attendantsPerformanceSubtitle' | translate }}
          </h5>
        </div>
      </div>
      <div class="card-body table-responsive">
        @if (loadingSpinner$ | async) {
          <loading-component />
        }

        <table class="table table-hover table-centered mb-0">
          <table-column-sort
                  [columns]="[
                    { label: ('dashboard.dashboard.colName' | translate), field: 'user', type: 'string' },
                    {
                      label: ('dashboard.dashboard.colTotalChats' | translate),
                      field: 'totalChat',
                      type: 'number',
                    },
                    {
                      label: ('dashboard.dashboard.colPending' | translate),
                      field: 'totalPending',
                      type: 'number',
                    },
                    {
                      label: ('dashboard.dashboard.colOpen' | translate),
                      field: 'totalInProgress',
                      type: 'number',
                    },
                    { label: ('dashboard.dashboard.colPaused' | translate), field: 'totalPaused', type: 'number' },
                    { label: ('dashboard.dashboard.colClosed' | translate), field: 'totalClosed', type: 'number' },
                    {
                      label: ('dashboard.dashboard.colClosedShare' | translate),
                      field: 'closedSharePercent',
                      type: 'number',
                    },
                    {
                      label: ('dashboard.dashboard.colTotalMessages' | translate),
                      field: 'totalMessages',
                      type: 'number',
                    },
                    {
                      label: ('dashboard.dashboard.colMessagesPerChat' | translate),
                      field: 'messagesPerChatValue',
                      type: 'number',
                    },
                  ]"
            [data]="attendanceOn?.list || []"
            (sortedData)="sortedAttendanceList = $any($event)"
            />
          <tbody>
            @for (item of sortedAttendanceList; track $index) {
              <tr role="row">
                <td>
                  {{
                  item?.user?.length > 20
                  ? item?.user?.substring(0, 15) + "..."
                  : item?.user
                  }}
                  @if (isUserOnline($safeNavigationMigration(item?.email))) {
                    <span
                      class="badge campaign-badge is-ok badge-verse"
                      >{{ 'dashboard.dashboard.online' | translate }}</span
                      >
                    }
                  </td>
                  <td class="featured-item">
                    <span>{{ item.totalChat }}</span>
                  </td>
                  <td>
                    {{ item.totalPending }}
                  </td>
                  <td>
                    {{ item.totalInProgress }}
                  </td>
                  <td>
                    {{ item.totalPaused }}
                  </td>
                  <td>
                    {{ item.totalClosed }}
                  </td>
                  <td>
                    {{ closedShare(item) }}
                  </td>
                  <td>
                    {{ item.totalMessages }}
                  </td>
                  <td>
                    {{ messagesPerChat(item) }}
                  </td>
                </tr>
              }
            </tbody>
          </table>

          @if (attendanceOn.total > attendanceOn.perPage) {
            <paginator
              [pager]="attendanceOn"
              (onPager)="loadPageOnline($event)"
              />
          }
        </div>
      } @else {
        <div class="d-flex card-header card-header--icon">
          <i class="mdi mdi-account"></i>
          <div>
            <h3>{{ 'dashboard.dashboard.noAttendantPerformanceTitle' | translate }}</h3>
            <h5 class="text-muted fw-normal">
              {{ 'dashboard.dashboard.noAttendantPerformanceSubtitle' | translate }}
            </h5>
          </div>
        </div>
      }
    </div>
    } @placeholder {
    <div>{{ 'dashboard.dashboard.loading' | translate }}</div>
  }

  <!-- Birthday table -->
  @defer (on viewport) {
  <div class="row g-2">
    <div class="col-xs-12 col-lg-6 d-flex">
      <div class="card w-100">
        @if (pager.total > 0) {
          <div class="d-flex card-header card-header--icon">
            <i class="mdi mdi-cake"></i>
            <div>
              <h3>{{ 'dashboard.dashboard.birthdayOfMonthTitle' | translate }}</h3>
              <h5 class="text-muted fw-normal">
                {{ 'dashboard.dashboard.birthdayOfMonthSubtitle' | translate }}
              </h5>
            </div>
          </div>
          <div class="card-body table-responsive">
            <table class="table table-hover table-centered mb-0">
              <table-column-sort
                      [columns]="[
                        { label: ('dashboard.dashboard.colName' | translate), field: 'name', type: 'string' },
                        { label: ('dashboard.dashboard.colDate' | translate), field: 'birthDate', type: 'date' },
                        { label: ('dashboard.dashboard.colAge' | translate), field: 'birthDate', type: 'date' },
                      ]"
                [data]="pager?.list || []"
                (sortedData)="sortedBirthdayList = $any($event)"
                />
              <tbody>
                @for (item of sortedBirthdayList; track $index) {
                  <tr>
                    <td>
                      <img
                        class="me-2 rounded-circle"
                        [alt]="item.name"
                        [src]="getUserImage($any(item))"
                        (error)="onImageError($event)"
                        />
                      <strong>{{ item.name }}</strong>
                    </td>
                    <td>
                      {{ item.birthDate | date: "dd/MM/yyyy" }}
                    </td>
                    <td>{{ 'dashboard.dashboard.ageYears' | translate: { age: transform(item.birthDate) } }}</td>
                  </tr>
                }
              </tbody>
            </table>

            @if (pager.total > pager.perPage) {
              <paginator [pager]="pager" (onPager)="loadPage($event)" />
            }
          </div>
        } @else {
          <div class="d-flex card-header card-header--icon">
            <i class="mdi mdi-account"></i>
            <div>
              <h3>{{ 'dashboard.dashboard.noBirthdayOfMonthTitle' | translate }}</h3>
              <h5 class="text-muted fw-normal">
                {{ 'dashboard.dashboard.noBirthdayOfMonthSubtitle' | translate }}
              </h5>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="col-xs-12 col-lg-6 d-flex">
      <div class="card w-100">
        @if (mostAccessedMenus?.length > 0) {
          <div class="d-flex card-header card-header--icon">
            <div>
              <h3>{{ 'dashboard.dashboard.mostAccessedMenusTitle' | translate }}</h3>
              <h5 class="text-muted fw-normal">
                {{ 'dashboard.dashboard.mostAccessedMenusSubtitle' | translate }}
              </h5>
            </div>
          </div>
          <div class="card-body card-body table-responsive">
            <div style="max-height: 320px; overflow-y: auto">
              <table class="table table-hover table-centered mb-0">
                <table-column-sort
                        [columns]="[
                          {
                            label: ('dashboard.dashboard.colMenu' | translate),
                            field: 'menu',
                            type: 'string',
                            cssClass: 'text-primary-emphasis ps-3',
                          },
                          {
                            label: ('dashboard.dashboard.colAccess' | translate),
                            field: 'count',
                            type: 'number',
                            cssClass: 'text-primary-emphasis text-end pe-3',
                          },
                        ]"
                  [data]="mostAccessedMenus || []"
                  (sortedData)="sortedMenuList = $any($event)"
                  />
                <tbody>
                  @for (item of sortedMenuList; track $index) {
                    <tr>
                      <td
                        class="ps-3 text-truncate"
                        style="max-width: 220px"
                        >
                        <strong>{{ item.menu.join(" ➝ ") }}</strong>
                      </td>
                      <td class="text-end featured-item">
                        <span>
                          {{ item.count }}
                        </span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        } @else {
          <div class="d-flex card-header card-header--icon">
            <i class="mdi mdi-account"></i>
            <div>
              <h3>{{ 'dashboard.dashboard.noMenuAccessedTitle' | translate }}</h3>
              <h5 class="text-muted fw-normal">
                {{ 'dashboard.dashboard.noMenuAccessedSubtitle' | translate }}
              </h5>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  } @placeholder {
  <div>{{ 'dashboard.dashboard.loading' | translate }}</div>
}
</div>
</div>

@if (getModuleCRM()) {
  <div
    class="tab-pane fade"
    id="crm-trend"
    role="tabpanel"
    aria-labelledby="crm-trend-tab"
    >
    <div class="mt-3">
      <app-dashboard-crm />
    </div>
  </div>
}


<!-- Painel TV: reads itself every five minutes, but only while this is the tab on screen. -->
<div
  class="tab-pane fade"
  id="tv"
  role="tabpanel"
  aria-labelledby="tv-tab"
  >
  <div class="mt-3">
    <app-dashboard-tv />
  </div>
</div>

@if (isAdmin()) {
  <!-- Business parameters and attendance goals: what colours the traffic lights above and
       prices the money estimates. Only an administrator may change them. -->
  <div
    class="tab-pane fade"
    id="goals"
    role="tabpanel"
    aria-labelledby="goals-tab"
    >
    <div class="mt-3">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box pb-1">
            <h4 class="page-title">{{ 'dashboard.dashboard.goalsPageTitle' | translate }}</h4>
          </div>
          <p class="text-muted">{{ 'dashboard.dashboard.goalsPageSubtitle' | translate }}</p>
        </div>
      </div>

      <form [formGroup]="goalsForm">
        <div class="row g-3">
          <div class="col-12 col-xl-6">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <h4 class="header-title mb-3">{{ 'dashboard.dashboard.goalsMoneyCard' | translate }}</h4>

                <div class="mb-3">
                  <label class="form-label" for="averageTicket">{{ 'dashboard.dashboard.goalsAverageTicket' | translate }}</label>
                  <input id="averageTicket" type="number" min="0" class="form-control" formControlName="averageTicket" />
                  <p class="mb-0 mt-1"><strong>{{ 'dashboard.dashboard.goalsAverageTicketReference' | translate }}</strong></p>
                  <span class="help-block"><small>{{ 'dashboard.dashboard.goalsAverageTicketHelp' | translate }}</small></span>
                </div>

                <div class="mb-3">
                  <label class="form-label" for="conversionWithinDeadline">{{ 'dashboard.dashboard.goalsConversion' | translate }}</label>
                  <input id="conversionWithinDeadline" type="number" min="0" max="100" class="form-control" formControlName="conversionWithinDeadline" />
                  <p class="mb-0 mt-1"><strong>{{ 'dashboard.dashboard.goalsConversionReference' | translate }}</strong></p>
                  <span class="help-block"><small>{{ 'dashboard.dashboard.goalsConversionHelp' | translate }}</small></span>
                </div>

                <div class="alert alert-secondary py-2 mb-3" role="alert">
                  <p class="mb-0">{{ 'dashboard.dashboard.goalsConversionExample' | translate }}</p>
                </div>

                <div class="mb-3">
                  <label class="form-label" for="monthlySalesTarget">{{ 'dashboard.dashboard.goalsMonthlySalesTarget' | translate }}</label>
                  <input id="monthlySalesTarget" type="number" min="0" class="form-control" formControlName="monthlySalesTarget" />
                  <p class="mb-0 mt-1"><strong>{{ 'dashboard.dashboard.goalsMonthlySalesTargetReference' | translate }}</strong></p>
                  <span class="help-block"><small>{{ 'dashboard.dashboard.goalsMonthlySalesTargetHelp' | translate }}</small></span>
                </div>

                <h5 class="mt-3 mb-1">{{ 'dashboard.dashboard.goalsAssumptionsTitle' | translate }}</h5>
                <p class="text-muted mb-0">{{ 'dashboard.dashboard.goalsAssumptionsText' | translate }}</p>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-6">
            <div class="card h-100 mb-0">
              <div class="card-body">
                <h4 class="header-title mb-3">{{ 'dashboard.dashboard.goalsAttendanceCard' | translate }}</h4>

                <h5 class="text-uppercase text-muted mb-2">{{ 'dashboard.dashboard.goalsFirstResponseGroup' | translate }}</h5>

                <div class="mb-3">
                  <label class="form-label" for="firstResponseMinutes">{{ 'dashboard.dashboard.goalsFirstResponseMinutes' | translate }}</label>
                  <input id="firstResponseMinutes" type="number" min="1" class="form-control" formControlName="firstResponseMinutes" />
                  <button type="button" class="btn btn-sm btn-soft-primary mt-2" (click)="useSuggestion('firstResponseMinutes')">
                    {{ 'dashboard.dashboard.goalsUseSuggestionMinutes' | translate:{ value: suggestionOf('firstResponseMinutes') } }}
                  </button>
                  <p class="mb-0 mt-1"><strong>{{ 'dashboard.dashboard.goalsFirstResponseReference' | translate }}</strong></p>
                  <span class="help-block"><small>{{ 'dashboard.dashboard.goalsFirstResponseHelp' | translate }}</small></span>
                </div>

                <div class="mb-3">
                  <label class="form-label" for="slaTarget">{{ 'dashboard.dashboard.goalsSlaTarget' | translate }}</label>
                  <input id="slaTarget" type="number" min="1" max="100" class="form-control" formControlName="slaTarget" />
                  <button type="button" class="btn btn-sm btn-soft-primary mt-2" (click)="useSuggestion('slaTarget')">
                    {{ 'dashboard.dashboard.goalsUseSuggestionPercent' | translate:{ value: suggestionOf('slaTarget') } }}
                  </button>
                  <p class="mb-0 mt-1"><strong>{{ 'dashboard.dashboard.goalsSlaReference' | translate }}</strong></p>
                  <span class="help-block"><small>{{ 'dashboard.dashboard.goalsSlaHelp' | translate }}</small></span>
                </div>

                <h5 class="text-uppercase text-muted mb-2 mt-4">{{ 'dashboard.dashboard.goalsHandlingGroup' | translate }}</h5>

                <div class="mb-3">
                  <label class="form-label" for="tmaMinutes">{{ 'dashboard.dashboard.goalsTmaMinutes' | translate }}</label>
                  <input id="tmaMinutes" type="number" min="1" class="form-control" formControlName="tmaMinutes" />
                  <button type="button" class="btn btn-sm btn-soft-primary mt-2" (click)="useSuggestion('tmaMinutes')">
                    {{ 'dashboard.dashboard.goalsUseSuggestionMinutes' | translate:{ value: suggestionOf('tmaMinutes') } }}
                  </button>
                  <p class="mb-0 mt-1"><strong>{{ 'dashboard.dashboard.goalsTmaReference' | translate }}</strong></p>
                  <span class="help-block"><small>{{ 'dashboard.dashboard.goalsTmaHelp' | translate }}</small></span>
                </div>

                <div class="mb-3">
                  <label class="form-label" for="abandonmentMax">{{ 'dashboard.dashboard.goalsAbandonmentMax' | translate }}</label>
                  <input id="abandonmentMax" type="number" min="0" max="100" class="form-control" formControlName="abandonmentMax" />
                  <button type="button" class="btn btn-sm btn-soft-primary mt-2" (click)="useSuggestion('abandonmentMax')">
                    {{ 'dashboard.dashboard.goalsUseSuggestionPercent' | translate:{ value: suggestionOf('abandonmentMax') } }}
                  </button>
                  <p class="mb-0 mt-1"><strong>{{ 'dashboard.dashboard.goalsAbandonmentReference' | translate }}</strong></p>
                  <span class="help-block"><small>{{ 'dashboard.dashboard.goalsAbandonmentHelp' | translate }}</small></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right-aligned, secondary first and the primary last: the shape every other form on
             the product uses (company-config, response-automatic) and the one the modal pattern
             in the design system shows. -->
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button type="button" class="btn btn-light" [disabled]="savingGoals" (click)="resetGoals()">
            {{ 'dashboard.dashboard.goalsResetToDefault' | translate }}
          </button>
          <button type="button" class="btn btn-primary" [disabled]="savingGoals" (click)="saveGoals()">
            {{ 'dashboard.dashboard.goalsSave' | translate }}
            @if (savingGoals) {
              <mat-spinner class="d-inline-block ms-1 align-middle" [diameter]="15" [color]="'accent'" mode="indeterminate" />
            }
          </button>
        </div>
      </form>
    </div>
  </div>
}

<!-- <div
class="tab-pane fade"
id="tasks"
role="tabpanel"
aria-labelledby="tasks-tab"
>
<div class="alert alert-danger mb-0 mt-3" role="alert">
  <h5 class="mb-1">Em breve...</h5>
</div>
</div> -->
</div>
